module.exports = __webpack_public_path__ + "img/logo_mfg.5e53edcf.svg";